export const MAX_DISPLAYED_HOTSPOTS_COUNT = 10;

export const iconUrl = 'https://assets.thdstatic.com/images/v1/product-hotspot.svg';
export const closeUrl = 'https://assets.thdstatic.com/images/v1/close-symbol-orange.svg';
